import * as types from "../../actions/types/index";

const INITIAL_STATE = {};
export default function (state = INITIAL_STATE, action) {

    switch (action.type) {
        case types.INITIALIZA_TOKBOX:
            return {
                ...state,
                payload: action.payload
            };
        default:
            return {
                ...state
            }
    }
}